import UnderConstruction from "../../errors/under-construction";

const CompanyLevel = (): JSX.Element => {
  return <UnderConstruction />;
};

export default CompanyLevel;
